import React from "react";
import { API_URLS } from "../config";
import SessionList from "../Components/SessionList";

const ActiveDevices = () => {
  return (
    <div style={{ padding: "2rem", maxWidth: 640 }}>
      <h2 style={{ marginBottom: "0.25rem" }}>Active Devices</h2>
      <p style={{ color: "#6b7280", marginBottom: "1.5rem" }}>
        These are the devices currently signed in to your account. If you don't recognize one, log it out.
      </p>

      <SessionList
        listUrl={API_URLS.SESSIONS}
        revokeUrl={(id) => `${API_URLS.SESSIONS}/${id}`}
        emptyLabel="No active devices found."
      />
    </div>
  );
};

export default ActiveDevices;
